import { combineReducers } from "@reduxjs/toolkit";
import { accAPI } from "../services/index";
import { corePlusIncentivesApi } from "../services/CorePlusIncentives/corePlusIncentivesApi";
import { mybizShellAPI } from "../services/MyBizShell/mybizShellAPI";
import { savedKpiPreferencesAPI } from "../services/KPIPreferences/savedKpiPreferencesAPI";
import { frontlineGroupGrowthAPI } from "../services/GroupGrowth/FrontlineGroupGrowth/frontlineGroupGrowthAPI";
import { ssiAPI } from "../services/StrongStart/ssiAPI";
import { ssiV2API } from "../services/StrongStart/ssiV2API";
import { personalGroupGrowthAPI } from "../services/GroupGrowth/PersonalGroupGrowth/personalGroupGrowthAPI";
import { pggGcrAPI } from "../services/GroupGrowth/PersonalGroupGrowthGCR/personalGroupGrowthGCRAPI";
import { monthlyPGGAPI } from "../services/GroupGrowth/MonthlyPersonalGroupGrowth/monthlyPGGAPI";
import { lsiAPI } from "../services/LeadershipSeminar/leadershipSeminarAPI";
import { performancePlusEliteAPI } from "../services/PerformancePlusElite/performancePlusEliteAPI";
import { ssiUplineApi } from "../services/SSIUpline/ssiUplineAPI";
import { qcgAPI } from "../services/GroupGrowth/QcGrowth/qcGrowthAPI";
import { bronzeGroupTrackingAPI } from "../services/BronzeGroupTracking/bronzeGroupTracking";
import { ttciAPI } from "../services/TwoTimeCashIncentives/TwoTimeCashIncentives";
import { csiAPI } from "../services/CustomerSalesIncentive/CustomerSalesIncentive";
import { visionBonusAPI } from "../services/VisionBonus/VisionBonusAPI";
import { higherAwardTrackingAPI } from "../services/HigherAwardTracking/HigherAwardTrackingAPI";
import { legsTrackingAPI } from "../services/HigherAwardTracking/LegsTracking/legsTrackingAPI";
import { monthlyQAPI } from "../services/MonthlyQ/monthlyQAPI";
import { frontlineQAPI } from "../services/FrontlineQ/frontlineQAPI";
import demoReducer from "./demo";
import periodReducer from "./period";
import profileReducer from "./profile";
import bronzeIncentiveReducer from "./bronzeIncentive";
import bootReducer from "./boot";
import loginLocalStorageReducer from "./loginLocalStorage";
import eligibilityTabReducer from "./eligibilityTab";
import bronzeGroupTrackingTabReducer from "./bronzeGroupTrackingTab";
import customersReducer from "./customer/customers";
import customerFilterReducer from "./customer/customerFilter";
import mbiFilterReducer from "./mbi/filter";
import customerSortReducer from "./customer/sort";
import ordersReducer from "./order/orders";
import orderFilterReducer from "./order/filter";
import BGTTrackingFilterReducer from "./BronzeGroupTracking/tracking/filter";
import orderSortReducer from "./order/sort";
import newCustomersReducer from "./customer/newCustomers";
import profileOrdersReducer from "./order/profileOrders";
import customerExportReducer from "./customer/customerExport";
import trackingSortReducer from "./BronzeGroupTracking/tracking/sort";
import bronzeGroupTrackingReducer from "./BronzeGroupTracking/bronzeGroupTracking";
import bgtGraduatedFilterReducer from "./BronzeGroupTracking/graduated/filter";
import bgtGraduatedSort from "./BronzeGroupTracking/graduated/sort";
import aboNameReducer from "./aboName";
import businessSelectorReducer from "./businessSelector";
import savedKpiPreferencesReducer from "./savedKpiPreferences";
import componentLoaderReducer from "./componentLoader";
import earningCalculatorReducer from "./earningCalculator";
import higherAwardTrackingReducer from "./higherAwardTracking";
import exportReducer from "./export";
import ssiUplineReport from "./ssiUplineReport";
import whosNewArReport from "./whosNewArReport";
import renewalsArReport from "./renewalsArReport";
import whosCloseArReport from "./whosCloseArReport";
import groupLeaderFilterReducer from "./groupLeaderFilter";
import cvrArReport from "./cvrArReport";
import birthdaysArReport from "./birthdaysArReport";
import nbbvArReport from "./nbbvArReport";
import cbrArReport from "./cbrArReport";
import iboOnboardingArReport from "./iboOnboardingArReport";
import aboEnrichmentReducer from "./aboEnrichment";
import navigationSelectionReducer from "./navigationSelection";
import { actionReportsApi } from "../services/ActionReports/ActionReportAPI";
import "../services/ActionReports/WatchlistBff";
import { aboEnrichmentAPI } from "../services/AboEnrichment/AboEnrichmentAPI";
import { qMonthHistoryApi } from "../services/QMonthHistory/qMonthHistoryAPI";
import watchlistReducer from "./watchlist";
import showDataReducer from "./showData";
import { treeViewApi } from "../services/TreeView/TreeViewAPI";
import { academyAPI } from "../services/Academy/academyAPI";
import { groupManagementOverviewAPI } from "../services/GroupManagementOverview/groupManagementOverviewAPI";
import { dataviewAPI } from "../services/Dataview/DataviewAPI";
import { annualIncomeDashboardAPI } from "../services/AnnualIncomeDashboard/annualIncomeDashboardAPI";
import { aboProfileAPI } from "../services/AboProfile/AboProfileAPI";
import { profileImageAPI } from "../services/ActionReports/ProfileImageAPI";
import uiStateReducer from "./uiState";
import profileImagesReducer from "./profileImages";
import whatsAppEnrichmentReducer from "./whatsAppEnrichment";
import treeViewUiStateReducer from "./treeViewUiState";
import downlineProfileReducer from "./downlineProfile";
const combinedReducer = combineReducers({
  demo: demoReducer,
  period: periodReducer,
  customerFilter: customerFilterReducer,
  mbiFilter: mbiFilterReducer,
  profile: profileReducer,
  bronzeIncentive: bronzeIncentiveReducer,
  customerExport: customerExportReducer,
  orderFilter: orderFilterReducer,
  BGTTrackingFilter: BGTTrackingFilterReducer,
  boot: bootReducer,
  loginLocalStorage: loginLocalStorageReducer,
  [corePlusIncentivesApi.reducerPath]: corePlusIncentivesApi.reducer,
  [higherAwardTrackingAPI.reducerPath]: higherAwardTrackingAPI.reducer,
  [savedKpiPreferencesAPI.reducerPath]: savedKpiPreferencesAPI.reducer,
  eligiblityTab: eligibilityTabReducer,
  bronzeGroupTrackingTab: bronzeGroupTrackingTabReducer,
  [accAPI.reducerPath]: accAPI.reducer,
  customers: customersReducer,
  newCustomers: newCustomersReducer,
  customerSort: customerSortReducer,
  orderSort: orderSortReducer,
  orders: ordersReducer,
  profileOrders: profileOrdersReducer,
  trackingSort: trackingSortReducer,
  bronzeGroupTracking: bronzeGroupTrackingReducer,
  ssiUplineReportTracker: ssiUplineReport,
  whosNewActionReportTracker: whosNewArReport,
  renewalActionReportTracker: renewalsArReport,
  whosCloseActionReportTracker: whosCloseArReport,
  groupLeaderFilter: groupLeaderFilterReducer,
  cvrActionReportTracker: cvrArReport,
  birthdaysActionReportTracker: birthdaysArReport,
  nbbvActionReportTracker: nbbvArReport,
  cbrActionReportTracker: cbrArReport,
  iboOnboardingActionReportTracker: iboOnboardingArReport,
  BGTGraduatedFilter: bgtGraduatedFilterReducer,
  BGTGraduatedSort: bgtGraduatedSort,
  aboName: aboNameReducer,
  businessSelectorData: businessSelectorReducer,
  savedKpiPreferencesData: savedKpiPreferencesReducer,
  [mybizShellAPI.reducerPath]: mybizShellAPI.reducer,
  [frontlineGroupGrowthAPI.reducerPath]: frontlineGroupGrowthAPI.reducer,
  [ssiAPI.reducerPath]: ssiAPI.reducer,
  [ssiV2API.reducerPath]: ssiV2API.reducer,
  [lsiAPI.reducerPath]: lsiAPI.reducer,
  [qcgAPI.reducerPath]: qcgAPI.reducer,
  [personalGroupGrowthAPI.reducerPath]: personalGroupGrowthAPI.reducer,
  [performancePlusEliteAPI.reducerPath]: performancePlusEliteAPI.reducer,
  [ssiUplineApi.reducerPath]: ssiUplineApi.reducer,
  componentLoader: componentLoaderReducer,
  [pggGcrAPI.reducerPath]: pggGcrAPI.reducer,
  [monthlyPGGAPI.reducerPath]: monthlyPGGAPI.reducer,
  [bronzeGroupTrackingAPI.reducerPath]: bronzeGroupTrackingAPI.reducer,
  [ttciAPI.reducerPath]: ttciAPI.reducer,
  [csiAPI.reducerPath]: csiAPI.reducer,
  [visionBonusAPI.reducerPath]: visionBonusAPI.reducer,
  [legsTrackingAPI.reducerPath]: legsTrackingAPI.reducer,
  earningCalculator: earningCalculatorReducer,
  higherAwardTracking: higherAwardTrackingReducer,
  [monthlyQAPI.reducerPath]: monthlyQAPI.reducer,
  [frontlineQAPI.reducerPath]: frontlineQAPI.reducer,
  exports: exportReducer,
  aboEnrichment: aboEnrichmentReducer,
  navigationSelection: navigationSelectionReducer,
  [actionReportsApi.reducerPath]: actionReportsApi.reducer,
  [aboEnrichmentAPI.reducerPath]: aboEnrichmentAPI.reducer,
  [qMonthHistoryApi.reducerPath]: qMonthHistoryApi.reducer,
  watchlist: watchlistReducer,
  showData: showDataReducer,
  [treeViewApi.reducerPath]: treeViewApi.reducer,
  [academyAPI.reducerPath]: academyAPI.reducer,
  [groupManagementOverviewAPI.reducerPath]: groupManagementOverviewAPI.reducer,
  [dataviewAPI.reducerPath]: dataviewAPI.reducer,
  [annualIncomeDashboardAPI.reducerPath]: annualIncomeDashboardAPI.reducer,
  [aboProfileAPI.reducerPath]: aboProfileAPI.reducer,
  [profileImageAPI.reducerPath]: profileImageAPI.reducer,
  profileImages: profileImagesReducer,
  whatsAppEnrichment: whatsAppEnrichmentReducer,
  uiState: uiStateReducer,
  treeViewUiState: treeViewUiStateReducer,
  downlineProfile: downlineProfileReducer,
});

export default combinedReducer;
